import React from 'react'
import PrinterInputs from './PrinterInputs'
import { usePrinterExtraStore } from '../../state/storePrinterExtra';

type Props = {}

const PrinterLeftTextInput = (props: Props) => {
  const [printerLeft, setPrinterLeft] = React.useState({
    printer_left1: '',
    printer_left2: '',
    printer_left3: '',
    printer_left4: '',
    printer_left5: '',
    printer_left6: '',
    printer_left7: '',})
    const {
        printer_left1,
        printer_left2,
        printer_left3,
        printer_left4,
        printer_left5,
        printer_left6,
        printer_left7,
   
      } = usePrinterExtraStore((state) => state);
      React.useEffect(() => {
        setPrinterLeft({
          printer_left1,
          printer_left2,
          printer_left3,
          printer_left4,
          printer_left5,
          printer_left6,
          printer_left7,
        })
      }, [printer_left1, printer_left2, printer_left3, printer_left4, printer_left5, printer_left6, printer_left7])

  return (
    <div className="p-2 flex-1 mt-7">
        <span className="text-slate-700 text-lg">Left</span>
        <PrinterInputs
          value={printerLeft.printer_left1}
          label="printer_left1"
          type="text"
        />
        <PrinterInputs
          value={printerLeft.printer_left2}
          label="printer_left2"
          type="text"
        />
        <PrinterInputs
          value={printerLeft.printer_left3}
          label="printer_left3"
          type="text"
        />
        <PrinterInputs
          value={printerLeft.printer_left4}
          label="printer_left4"
          type="text"
        />
        <PrinterInputs
          value={printerLeft.printer_left5}
          label="printer_left5"
          type="text"
        />
        <PrinterInputs
          value={printerLeft.printer_left6}
          label="printer_left6"
          type="text"
        />
        <PrinterInputs
          value={printerLeft.printer_left7}
          label="printer_left7"
          type="text"
        />
      </div>
  )
}

export default PrinterLeftTextInput